import React, { Component } from "react";
import MetricsImg from "../../../images/Metric.png";
import caretImg from "../../../images/caret.png";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import ReactApexChart from "react-apexcharts";
import { Button } from "react-bootstrap";
import SetMetricsModal from "../modals/set-metrics-modal/set-metrics-modal";
import { getAppMetricsData } from "../../api";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import addDays from "date-fns/addDays";
import subDays from "date-fns/subDays";
import { subYears, startOfYear, endOfYear, subMonths } from "date-fns";
import SelectDropDown from "./drop-down";

const DASHED_FILTER = ["Last_3_Months", "Last_6_Months", "Current_Year", "All"];

class AppsMetrics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            progressionData: [],
            timePeriodValue: "Last_7_Days",
            timePeriod: [],
            calenderValue: [],
            series: [
                {
                    name: "",
                    data: [],
                },
            ],
            options: {
                chart: {
                    toolbar: {
                        show: false,
                    },
                    height: 350,
                    type: "area",
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "straight",
                    width: 2,
                    lineCap: "round",
                },
                fill: {
                    type: "solid",
                    colors: ["transparent"],
                },
                xaxis: {
                    type: "category",
                    categories: [],
                },
                yaxis: {
                    labels: {
                        show: true,
                    },
                    max: 10,
                },
                tooltip: {
                    x: {
                        format: "MM/dd/yy",
                    },
                },
                colors: ["#44AE42"],
                legend: {
                    show: false,
                },
            },
            setMetricsModalShow: false,
            selectedStatuses: [],
            dropUserText: "",
            user: "",
        };
        this.element = React.createRef();
    }

    getMetricsData(data) {
        const currentDate = new Date();
        const currentMonthName = currentDate.toLocaleString("default", {
            month: "long",
        });
        getAppMetricsData(data)
            .then((res) => {
                // Check if the selected filter is in the DASHED_FILTER array
                let isCurrentMonthLast = false;
                let goingMonth = currentMonthName;
                if (DASHED_FILTER?.includes(this.state?.timePeriodValue)) {
                    isCurrentMonthLast =
                        res?.categories[res?.categories.length - 1]?.includes(
                            currentMonthName,
                        );
                }
                if (isCurrentMonthLast) {
                    goingMonth = res?.categories[res?.categories.length - 1];
                }
                let currentMonthIndex = res?.categories.indexOf(goingMonth);
                const dataSize = res?.statuses?.length;
                const dashedArray = Array(dataSize)
                    .fill(0)
                    .concat(Array(dataSize).fill(6));
                const customStroke = {
                    width: 2,
                    lineCap: "round",
                    dashArray: dashedArray,
                };
                let customColor = res.colors;
                // Create a series with only the previous month
                const seriesExcludeCurrentMonth = res.series.map((series) => ({
                    name: series.name,
                    data: series.data.map((_, index) => {
                        if (index !== currentMonthIndex) {
                            return series.data[index];
                        } else {
                            return null;
                        }
                    }),
                }));
                // Create a series with only the current month
                const seriesCurrentMonth = res.series.map((series) => ({
                    name: `${series.name} - (Current Month)`,
                    data: series.data.map((_, index) => {
                        if (
                            index === currentMonthIndex ||
                            index === currentMonthIndex - 1
                        ) {
                            return series.data[index];
                        } else {
                            return null;
                        }
                    }),
                }));
                const customSeries = isCurrentMonthLast
                    ? [...seriesExcludeCurrentMonth, ...seriesCurrentMonth]
                    : res.series;

                this.setState({
                    series: customSeries,
                    selectedStatuses: res.statuses,
                    loading: false,
                });

                this.setState((prev) => ({
                    options: {
                        ...prev.options,
                        colors: customColor,
                        stroke: customStroke,
                    },
                }));

                this.setState((prev) => ({
                    options: {
                        ...prev.options,
                        xaxis: {
                            type: "category",
                            categories: res?.categories,
                        },
                        yaxis: {
                            forceNiceScale: true,
                            labels: {
                                show: true,
                                formatter: function (val) {
                                    return val?.toFixed(0);
                                },
                            },
                            max: res?.maxValue + 2,
                        },
                    },
                }));
            })
            .catch((err) => {
                this.setState({
                    series: [],
                    loading: false,
                });
            });
    }

    handleProcessingAppDateChange(dates) {
        this.setState({
            timePeriodValue: "Custom_date",
            calenderValue: dates,
        });
        this.setState({
            timePeriod: [
                dates[0].toLocaleDateString("en-US"),
                dates[1].toLocaleDateString("en-US"),
            ],
        });
        const metricData = {
            startDate: dates[0].toLocaleDateString("en-US"),
            endDate: dates[1].toLocaleDateString("en-US"),
            selectedStatuses: this.state.selectedStatuses,
            user: this.state.user,
        };
        this.getMetricsData(metricData);
    }

    handlePeriodChange = (e) => {
        e.persist();
        var date = new Date();
        let params = {};
        this.setState({
            timePeriodValue: e.target.value,
            calenderValue: [startOfDay(new Date()), endOfDay(new Date())],
            loading: true,
        });

        if (e.target.value === "Last_7_Days") {
            params = {
                firstDate: subDays(date, 6).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Current_month") {
            params = {
                firstDate: new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    1,
                ).toLocaleDateString("en-US"),
                lastDate: new Date().toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Current_Year") {
            params = {
                firstDate: startOfYear(date).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Last_month") {
            params = {
                firstDate: new Date(
                    date.getFullYear(),
                    date.getMonth() - 1,
                    1,
                ).toLocaleDateString("en-US"),
                lastDate: new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    0,
                ).toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Last_3_Months") {
            params = {
                firstDate: subMonths(date, 3).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Last_6_Months") {
            params = {
                firstDate: subMonths(date, 6).toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Previous_Year") {
            params = {
                firstDate: startOfYear(subYears(date, 1)).toLocaleDateString(
                    "en-US",
                ),
                lastDate: endOfYear(subYears(date, 1)).toLocaleDateString(
                    "en-US",
                ),
            };
        } else if (e.target.value === "All") {
            params = {
                firstDate: new Date("01/01/2000").toLocaleDateString("en-US"),
                lastDate: date.toLocaleDateString("en-US"),
            };
        } else if (e.target.value === "Custom_date") {
            this.element.current.open();
            return;
        }

        this.setState({ timePeriod: [params.firstDate, params.lastDate] });
        const metricData = {
            startDate: params.firstDate,
            endDate: params.lastDate,
            selectedStatuses: this.state.selectedStatuses,
            user: this.state.user,
        };
        this.getMetricsData(metricData);
    };

    openModal = () => {
        this.setState({ setMetricsModalShow: true });
    };

    closeSetMetricsModal = () => {
        this.setState({ setMetricsModalShow: false });
    };

    updateSelectedStatuses = (data) => {
        const metricData = {
            startDate: this.state.timePeriod[0],
            endDate: this.state.timePeriod[1],
            selectedStatuses: data,
            user: this.state.user,
        };
        this.getMetricsData(metricData);
    };

    onRemoveStatus = (id) => {
        let filterData = this.state.selectedStatuses.filter((item, index) => {
            return item.id != id;
        });
        const metricData = {
            startDate: this.state.timePeriod[0],
            endDate: this.state.timePeriod[1],
            selectedStatuses: filterData,
            user: this.state.user,
        };
        this.getMetricsData(metricData);
    };

    componentDidMount = () => {
        let date = new Date();
        let params = {
            firstDate: subDays(date, 6).toLocaleDateString("en-US"),
            lastDate: date.toLocaleDateString("en-US"),
        };
        this.setState({ timePeriod: [params.firstDate, params.lastDate] });
        let selectedStatus = {
            name: "Approved",
            id: 12,
            color: "#44AE42",
            avgPerc: 0,
        };
        if (this.props?.user?.channel == "sales_channel") {
            selectedStatus = {
                name: "Approved",
                id: [18, 20],
                color: "#44AE42",
                avgPerc: 0,
            };
        }
        const metricData = {
            startDate: params.firstDate,
            endDate: params.lastDate,
            selectedStatuses: [selectedStatus, ...this.state.selectedStatuses],
            user: this.state.user,
        };
        this.getMetricsData(metricData);
    };

    handelUserChange = (e) => {
        let value = e.value;
        this.setState({
            user: value,
            loading: true,
        });
        if (value.split("-")[0] === "org") {
            this.setState({
                dropUserText: "Org",
            });
        } else {
            this.setState({
                dropUserText: "User",
            });
        }
        this.props.updateDropUser(value);
        const metricData = {
            startDate: this.state.timePeriod[0],
            endDate: this.state.timePeriod[1],
            selectedStatuses: this.state.selectedStatuses,
            user: value,
        };
        this.getMetricsData(metricData);
    };

    render() {
        const { afterToday } = DateRangePicker;
        const timePeriod = [
            "Last_7_Days",
            "Current_month",
            "Current_Year",
            "Last_month",
            "Last_3_Months",
            "Last_6_Months",
            "Previous_Year",
            "All",
            "Custom_date",
        ];
        const { loading } = this.state;
        return (
            <div className="app">
                <div className="shadow-card">
                    <div className="row app-process-metric app-process-row">
                        <div className="col-md-6 col">
                            <img style={{ width: "auto" }} src={MetricsImg} />
                            <h4>Applications processing metrics</h4>
                        </div>
                        <div className="col-md-6 col">
                            <div className="d-flex">
                                <div className="d-flex align-items-center datePickerParentClass">
                                    <div className="myDatePicker datepicker-range-app data-picker-metrics-area">
                                        <DateRangePicker
                                            ref={this.element}
                                            onChange={(value) => {
                                                this.handleProcessingAppDateChange(
                                                    value,
                                                );
                                            }}
                                            onOk={(value) => {
                                                this.handleProcessingAppDateChange(
                                                    value,
                                                );
                                            }}
                                            appearance="subtle"
                                            placeholder=""
                                            style={{ width: 28 }}
                                            disabledDate={afterToday()}
                                            cleanable={false}
                                            ranges={[
                                                {
                                                    label: "Yesterday",
                                                    value: [
                                                        addDays(new Date(), -1),
                                                        addDays(new Date(), -1),
                                                    ],
                                                },
                                                {
                                                    label: "Today",
                                                    value: [
                                                        new Date(),
                                                        new Date(),
                                                    ],
                                                },
                                                {
                                                    label: "Last 7 days",
                                                    value: [
                                                        subDays(new Date(), 6),
                                                        new Date(),
                                                    ],
                                                },
                                            ]}
                                            placement="rightStart"
                                        />
                                    </div>
                                    <div className="period-btn">
                                        <span>Period</span>
                                        <select
                                            style={{
                                                backgroundImage: `url(${caretImg})`,
                                            }}
                                            onChange={(e) =>
                                                this.handlePeriodChange(e)
                                            }
                                            name="periodoptn"
                                        >
                                            {timePeriod.map((item, index) => (
                                                <option
                                                    value={item}
                                                    key={index}
                                                >
                                                    {item.replace(/_/g, " ")}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {this.props.user.organization_id > 1 &&
                                this.props.user.role === "agent" ? null : (
                                    <div className="d-flex align-items-center analytics-filtering">
                                        <div className="test-orglist metric-btnselect">
                                            <span>
                                                {this.state.dropUserText}
                                            </span>
                                            <SelectDropDown
                                                options={
                                                    this.props.dropDownUsers
                                                }
                                                name="periodoptn"
                                                placeholder="Choose To Filter"
                                                value=""
                                                handleChange={(evt) =>
                                                    this.handelUserChange(evt)
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="app-metrics-dtl">
                        <Button className="set-goal" onClick={this.openModal}>
                            Set metrics
                        </Button>
                        <div className="d-flex goal-chart-col">
                            {this.state.selectedStatuses.map((item, index) => (
                                <div
                                    className={`d-flex dailygoal-detail1 ${item.id != 12 ? "cancelled-button-tab" : ""}`}
                                    key={index}
                                >
                                    <span
                                        className="dot"
                                        style={{ background: item.color }}
                                    ></span>
                                    {item.id != 12 ? (
                                        <p className="status-text">
                                            {item.name}
                                            <button
                                                onClick={() =>
                                                    this.onRemoveStatus(item.id)
                                                }
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>
                                        </p>
                                    ) : (
                                        <p className="status-text">
                                            {item.name}
                                        </p>
                                    )}
                                </div>
                            ))}
                        </div>
                        {loading ? (
                            <div className="app-metrics-loader-wrap">
                                <p className="loader"> </p>
                            </div>
                        ) : (
                            <div style={{ padding: "24px 0px" }}>
                                <ReactApexChart
                                    options={this.state.options}
                                    series={this.state.series}
                                    type="area"
                                    height={350}
                                />
                            </div>
                        )}
                    </div>
                    <hr />
                </div>

                {this.state.setMetricsModalShow && (
                    <SetMetricsModal
                        show={this.state.setMetricsModalShow}
                        closeModal={this.closeSetMetricsModal}
                        user={this.props.user}
                        updateSelectedStatuses={this.updateSelectedStatuses}
                        selectedStatuses={this.state.selectedStatuses}
                    />
                )}
            </div>
        );
    }
}

export default AppsMetrics;
